import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminAppBar from "../adminComponents/AdminAppBar";
import * as xlsx from "xlsx";
import axios from "axios";
import LeadUploadService from "../Services/LeadUploadService";
import leadSourceService from "../Services/LeadSourceService";
import InterestedTagService from "../Services/InterestedTagService";
import propertyService from "../Services/PropertyService";
import teamService from "../Services/TeamService";
import { bulkFolderPath, getIcons } from "../Constant/Constant";
import {  leadStatusMap } from "../../Enum";
import {interestLevel} from '../../Enum/LeadEnumConstants'
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
  showWarningToast,
} from "../Constant/Notification";
import AppBar from "../leadComponent/AppBar";

import LocationService from "../Services/LocationService";
import BulkCompletedModel from "../adminComponents/BulkCompletedModel";
import DuplicateLeadDownload from "../adminComponents/DuplicateLeadDownload";
import LeadLimitModel from "../adminComponents/LeadLimitModel";
import ValidationModal from "../shareableContainer/ValidationModal";
import SpinWheelService from "../Services/SpinWheelService";
import Loader from "../Constant/Loader";
import CustomButton from "../common/CustomButton";
import CustomHeading from "../common/CustomHeading";
import CustomSelect from "../common/CustomSelect";
import LeadSourceDropdown from "../Form/LeadTable/LeadSourceDropdown";
import AsteriskStyle from "../Form/Tooltip/AsteriskStyle";
import PropertiesService from "../Services/PropertiesService";
import { GLPagePropertyTypeList } from "../../Enum/GLPageEnumConstants";
import ConfirmationModal from "../shareableContainer/ConfirmationModal";
import TeamService from "../../GlobalSetupComponents/Services/TeamService";
import { managementDepartmentLabel, salesDepartmentLabel } from "../../GlobalSetupComponents/Enum/DepartmentEnum";
import UserService from "../../GlobalSetupComponents/Services/UserService";

const AdminBulkUpload = () => {
  const navigate = useNavigate();
  const icon = getIcons();

  const [fileImageUrl, setFileImageUrl] = useState("");

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  let bodTeamId;
  if (userRole === "BOD") {
    bodTeamId = userObj?.teamId[0].id;
  }

  const handleConfirmUpload = async () => {
    if (!validateForm()) return;

    let tags = interestTags.map((item) => item.value);
    let locationTags = interestLocationTags.map((item) => item.value);

    let obj;

    if (
      userRole === "Admin" ||
      userRole === "CMO" ||
      userRole === "Lead Uploader"
    ) {
      obj = {
        assignedTeam: selectedTeam.value,
        assignedUser: isAssignedUser ? selectedUser?.value : "",
        createdBy: userObj.user.uid,
        fieldWorker: selectedLeadGivenBy?.value,
        interestTags: tags,
        interestedLocations: locationTags,
        leadQuality: selectedLevel?.value || "",
        fileUrl: fileImageUrl,
        leadSource: selectedLeadSource.id,
        modifiedBy: userObj.user.uid,
        status: selectedStatus,
        sourceType : selectedSourceType || false,
        interestedPropertyId : selectedProperty?.value || null,
        interestedCategoryId : selectedPropertyType?.value || null,
      };
    } else if (userRole === "BOD") {
      obj = {
        assignedTeam: bodTeamId,
        assignedUser: selectedUser?.value || "",
        createdBy: userObj.user.uid,
        fieldWorker: selectedLeadGivenBy?.value,
        interestTags: tags,
        interestedLocations: locationTags,
        leadQuality: selectedLevel?.value || "",
        fileUrl: fileImageUrl,
        leadSource: selectedLeadSource.id,
        modifiedBy: userObj.user.uid,
        status: selectedStatus,
        sourceType : selectedSourceType || false,
        interestedPropertyId : selectedProperty?.value || null,
        interestedCategoryId : selectedPropertyType?.value || null,
      };
    }

    setLoading(true);

    

    try {
      const response = await LeadUploadService.createBulkUploadExcel(obj);
      console.log(response);
      showSuccessToast("Lead uploaded successfully");
      setTimeout(() => {
        navigate(-1);
      }, 1500);
      if (response?.status === 200) {
        //showSuccessToast(response.data);
        setSelectedFile(null);
        setSelectedLeadSource("");
        // setTimeout(() => {
        //   navigate(-1);
        // }, 1500);

        setFileImageUrl(null);
      } else {
        showErrorToast("Unexpected response from server.");
      }
    } catch (error) {
      console.error(error);
            if(error){
              showErrorToast(error?.response?.data);
             
            }
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };
  const [interestTags, setInterestTags] = useState([]);
  const [options, setOptions] = useState([]);
  const [success, setSuccess] = useState(false);
  const [leadStatus, setLeadStatus] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [inputJson, setInputJson] = useState(null);
  const [leadSource, setLeadSource] = useState([]);
    const [leadSourceSearch , setLeadSourceSearch] = useState("");
  const [properties, setProperties] = useState([]);
  const [teams, setTeams] = useState([]);
  const [isAssignedTeam, setIsAssignedTeam] = useState(false);
  const [isAssignedUser, setIsAssignedUser] = useState(false);
  const [budget, setBudget] = useState();
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [leadGivenUsers, setLeadGivenUsers] = useState([]);
  const [selectedLeadGivenBy, setSelectedLeadGivenBy] = useState();
  const [fieldWorkers, setFieldWorkers] = useState([]);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);

  const [interestedTags, setInterestedTags] = useState([]);

  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [selectedProperty, setSelectedProperty] = useState("");
  const [duplicates, setDuplicates] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(leadStatusMap["Fresh"]);

  const [selectedFieldWorker, setSelectedFieldWorker] = useState("");
  const [fieldWorkerError, setFieldWorkerError] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [selectedLevel, setSelectedLevel] = useState();
  const [validationErrors, setValidationErrors] = useState([]);
  const [showValidationModal, setShowValidationModal] = useState(false);


  const [propertyList, setPropretyList] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedSourceType, setSelectedSourceType] = useState(userRole === 'BOD' ? false : true);
   const [selectedPropertyType, setSelectedPropertyType] = useState();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);


  const handleSelectChange = (selectedOption) => {
    setSelectedLevel(selectedOption);
  };

  const validateForm = () => {
    const newErrors = {};
    let hasErrors = false;

    if (!selectedLeadSource) {
      newErrors.leadSource = "Lead Source is required";
      showErrorToast("Lead Source is required");
      hasErrors = true;
    }
    
    if (!selectedFile) {
      newErrors.selectedFile = "Selected file is required";
      showErrorToast("Selected file is required");
      hasErrors = true;
    }
    
    if (userRole !== "BOD" && !selectedTeam) {
      newErrors.teams = "Team is required";
      showErrorToast("Team is required");
      hasErrors = true;
    }
    if(userRole === "BOD")
    {
      if(!selectedUser)
      {
        newErrors.users = "User is required";
        showErrorToast("User is required");
        hasErrors = true;
      }

    }
    if(isAssignedUser)
    {
      if(!selectedUser)
      {
        newErrors.users = "User is required";
        showErrorToast("User is required");
        hasErrors = true;
      }
      if(!selectedTeam)
      {
        newErrors.teams = "Team is required";
        showErrorToast("Team is required");
        hasErrors = true;
      }
    }

    if(!selectedLevel)
    {
      newErrors.leadQuality = "Lead Quality is required";
      showErrorToast("Lead Quality is required");
      hasErrors = true;
    }
    
    if (!selectedStatus) {
      newErrors.status = "Status is required";
      showErrorToast("Status is required");
      hasErrors = true;
    }

    setOpenConfirmModal(false);
    setErrors(newErrors);
    
    return !hasErrors;
  };

  const handleChange = (selectedOptions) => {
    setInterestTags(selectedOptions);
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];

    if (file && !validFileTypes.includes(file.type)) {
      showInfoToast("Invalid file type. Only .xlsx or .csv files are allowed.");
      setSelectedFile(null);
      return;
    }

 
    

    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rawJson = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
        const headerRow = rawJson[0];

       

      

        if (!headerRow) {
          showInfoToast("No headers found in the file.");
          return;
        }

        

        const headerMap = {};
        headerRow.forEach((header, idx) => {
          if (header) {
            headerMap[String(header).replace(/\s+/g, "").toLowerCase().trim()] =
              idx;
          }
        });
        console.log("Header Map:", headerMap);

        const requiredHeaders = ["name", "phone", "email"];
        const missingHeaders = requiredHeaders.filter((h) => !(h in headerMap));

        if (missingHeaders.length > 0) {
          setValidationErrors([
            {
              row: "Header",
              field: "Missing Headers",
              message: "Missing required headers: " + missingHeaders.join(", "),
            },
          ]);
          setShowValidationModal(true);
          setSelectedFile(null);
          e.target.value = "";
          return;
        }

        const validationErrors = [];
        const cleanData = [];
        const phoneNumbers = new Set();
        const duplicateRows = [];

        // const dataRows = rawJson.slice(1);
        // const trimedDataRows = dataRows.map(row => row.map(cell => (typeof cell === 'string' ? cell.trim() : cell)));

        // if (trimedDataRows.length === 0 || trimedDataRows.every((row) => row.every(cell => !cell || String(cell).trim() === ""))) {
        //   showWarningToast("The file is empty or contains no valid data rows.");
        //   setSelectedFile(null);
        //   e.target.value = "";
        //   return;
        // }

        // if (trimedDataRows.length > 40000) {
        //   showInfoToast(
        //     "The file contains more than 40000 rows. Please upload a smaller file."
        //   );
        //   setSelectedFile(null);
        //   e.target.value = "";
        //   return;
        // }

        const dataRows = rawJson.slice(1);
const trimedDataRows = dataRows
  .map(row => row.map(cell => (typeof cell === 'string' ? cell.trim() : cell)))
  .filter(row => row.some(cell => cell && String(cell).trim() !== ""));

if (trimedDataRows.length === 0) {
  showWarningToast("The file is empty or contains no valid data rows.");
  setSelectedFile(null);
  e.target.value = "";
  return;
}

if (trimedDataRows.length > 40000) {
  showInfoToast(
    "The file contains more than 40000 rows. Please upload a smaller file."
  );
  setSelectedFile(null);
  e.target.value = "";
  return;
}

        trimedDataRows.forEach((row, index) => {
          const rowIndex = index + 2; // Excel row number

          const name = String(row[headerMap["name"]] || "").trim();
          const phone = String(row[headerMap["phone"]] || "").trim();
          const email = String(row[headerMap["email"]] || "").trim();

          if (name.length > 120) {
            validationErrors.push({
              row: rowIndex,
              field: "Name",
              message: "Name exceeds 120 characters",
            });
          }

          if (phone.length > 30) {
            validationErrors.push({
              row: rowIndex,
              field: "phone",
              message: "Invalid phone number. Maximum 30 characters allowed.",
            });
            return;
          }
          phoneNumbers.add(phone);

          cleanData.push({
            name,
            phoneNumber: phone,
            emailId: email,
          });
        });

        if (validationErrors.length > 0) {
          setValidationErrors(validationErrors);
          setShowValidationModal(true);
          setSelectedFile(null);
          e.target.value = "";
          return;
        }

        if (duplicateRows.length > 0) {
          setDuplicates(duplicateRows);
          setIsModalOpen2(true);
          setSelectedFile(null);
          e.target.value = "";
          return;
        }

        setInputJson(cleanData);

        try {
          setLoading(true);
          const formData = new FormData();
          formData.append("file", file);
          const response = await SpinWheelService.createBannerImageTemplate(
            formData,
            bulkFolderPath
          );
          console.log("Upload successful:", response.data);
          setFileImageUrl(response.data?.imageUrl);
        } catch (error) {
          console.error("API upload error:", error);
        } finally {
          setLoading(false);
        }
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };

  const handleLeadGiveUser = (selectedOptions) => {
    setSelectedLeadGivenBy(selectedOptions);
  };

  const handlePropertyType = (selectedPropertyType) => {
    setSelectedPropertyType(selectedPropertyType);
  };

  const handleSelectedUser = (selectedUser) => {
    console.log("Selected User:", selectedUser);
    setSelectedUser(selectedUser);
  };

  const handelSelectedTeam = (selectedTeam) => {
    setSelectedTeam(selectedTeam);
    setSelectedUser("");
  };


  const fetchLeadSourceData = async () => {
    try {
      const response = await leadSourceService.getLeadSource(leadSourceSearch);
      const data = response.data;
      console.log(data);
      setLeadSource(data || []);
    } catch (error) {
      console.error("Error fetching leadSources:", error);
      setLeadSource([])
    }
  }
  useEffect(()=>{
    fetchLeadSourceData();
  },[leadSourceSearch])

  useEffect(() => {
    (async () => {
     
      try {
        const response = await InterestedTagService.fetchInterestedTag();
        const responseLocation = await LocationService.fetchLocation();
        const data = response.data;
        const dataLocation = responseLocation.data;
        const formattedLocations = Object.entries(dataLocation).map(
          ([name, id]) => ({
            value: id,
            label: name,
          })
        );

        setOptionLocation(formattedLocations);
        console.log("Interest Location Data:", formattedLocations);
        //   console.log(data)
        setInterestedTags(data);
        let optionsArray = [];
        data.forEach((item) => {
          optionsArray.push({ value: item.id, label: item.name });
        });
        setOptions(optionsArray);
      } catch (error) {
        console.error("Error fetching interested tags:", error);
        // Handle error if needed
      }

      try {
        const response = await TeamService.getDepartmentTeamList({
          department: salesDepartmentLabel
        });
        const data = response.data || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
        // Handle error if needed
      }
      try {
        const response = await UserService.getDepartmentWithTeamMembers({
           departmentNames: [managementDepartmentLabel , salesDepartmentLabel],
          teamId: null,
        });
      
        const data = response.data?.users || [];

        setLeadGivenUsers(data);
      } catch (error) {
        console.log(error.message);
      }
    })();
  }, []);

  const fetchPropertyList = async (inputValue)=>{
 
    try {
      const response = await PropertiesService.getPropertyList(inputValue);
      const propertyData = response.data?.map((list) => ({
        value: list.id,
        label: list.name,
      }));
      setPropretyList(propertyData);
      console.log("propertyData" , response)
    } catch (err) {
      console.error("Failed to fetch property list", err);
    }
  }
  useEffect(()=>{
    fetchPropertyList("")
  },[])

  const handleInputChange = (newValue) => {
    fetchPropertyList(newValue);
  };
 
  const status = [
    "Fresh",
    "Follow-up",
    "Dealing",
    "Registered Client",
    "Deal Lost",
    "Unanswered",
    "Not Interested",
    "Retry Suitable",
  ];

  const handleLeadAssignChange = (type) => {
    if (type === "Assign to team") {
      setIsAssignedTeam(true);
      setIsAssignedUser(false);
    } else if (type === "Assign to user") {
      setIsAssignedTeam(true);
      setIsAssignedUser(true);
    }
  };
  const handleTeamChange = async (e) => {
    setSelectedTeam(e);
    setErrors((prevErrors) => ({ ...prevErrors, teams: "" }));
  };

  useEffect(() => {
    const fetchUsersByTeam = async () => {
      let teamIdToFetch = userRole === "BOD" ? bodTeamId : selectedTeam.value;

      if (teamIdToFetch) {
        try {
          const response = await UserService.getDepartmentWithTeamMembers({
           
            departmentNames:[managementDepartmentLabel , salesDepartmentLabel],
            teamId: teamIdToFetch,
          });
        
          const data = response.data;
         
          const combinedUsers = data.users || []

          const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];

        

          setUsers(finalUsers);
          console.log(users);
        } catch (error) {
          setUsers([]);
          console.error("Error fetching users by team:", error);
        }
      }
    };

    fetchUsersByTeam();
  }, [selectedTeam, isAssignedUser]);

  const handleLeadSourceChange = (e) => {
    setSelectedLeadSource(e);
    setSelectedLeadSourceId(e.value);
    setErrors((prevErrors) => ({ ...prevErrors, leadSources: "" }));
  };

  const handlePropertyChange = (e) => {
    setSelectedProperty(e);
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(leadStatusMap[e]);
    setErrors((prevErrors) => ({ ...prevErrors, status: "" }));
  };

  // const handleFieldWorkerChange = (e) => {
  //   setSelectedFieldWorker(e);
  // };

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/Sample lead upload Template.xlsx";
    link.setAttribute("download", "sample-template for bulk upload.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };
  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  return (
    <>
      {userRole === "Lead Uploader" ? <AppBar /> : <AdminAppBar />}

      {loading && <Loader />}
      <ToastContainer />

      <div className=" bg-appGrayBackground flex flex-col gap-8  mt-20 pt-4 px-6 pb-10">
        <div className="flex justify-between gap-5 ">
          <CustomHeading title="Bulk Lead Upload" isIcon={true} />

          <div className="">
            <CustomButton
              onClick={()=>{
                
                  setOpenConfirmModal(true);
              
              }}
              isDisabled={loading}
              label={"Upload"}
              className={"w-32 flex justify-center "}
            />
          </div>
        </div>

        <form className="px-[70px] mx-10 py-[37px] bg-white shadow rounded-[10px]">
        <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-xl font-medium"
              htmlFor="name"
            >
              Source Type <AsteriskStyle />
            </label>

            <div className="flex gap-8 items-center">
              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  id="manual"
                  name="sourceType"
                  value="Manual"
                  className="w-5 h-5 "
                  checked={selectedSourceType === true}
                  onChange={(e)=>{
                    setSelectedSourceType(true)
                  }}
                />
                <label>Managment Lead</label>
              </div>

              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  id="manual"
                  name="sourceType"
                  value="Manual"
                  className="w-5 h-5 "
                  checked={selectedSourceType === false}
                  onChange={(e)=>{
                    setSelectedSourceType(false)
                  }}
                />
                <label>Own Lead</label>
              </div>
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Lead Given By{" "}
            </label>
            <div className="flex w-3/4 relative">
              <CustomSelect
                value={selectedLeadGivenBy}
                onChange={handleLeadGiveUser}
                options={leadGivenUsers}
                placeholder="Select Lead Given By"
              />
            </div>
          </div>
          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Lead Source <span className="text-red-600">*</span>
            </label>
            <div className="flex w-3/4">
            <LeadSourceDropdown
              leadSource={leadSource}
              setLeadSourceSearch={setLeadSourceSearch}
              leadSourceSearch={leadSourceSearch}
              onSelect={(list) => {
                setSelectedLeadSource(list);
                ;
              }}
            />
              
            </div>
          </div>

          <div className="mb-8 ">
            <hr className="border-t border-gray-300 mx-4" />
          </div>

          <div className=" flex w-full justify-between">
            <div className="mb-8 flex justify-between w-full gap-5">
            <label className="w-1/4 text-black text-xl font-medium ">
                Attach File <AsteriskStyle/>
              </label>
              <label className="w-full ml-[100px] ">
                <div className="relative border  w-full py-3 px-2 text-gray-700 leading-tight focus:outline-customGreen rounded-[10px] cursor-pointer">
                  <span className="absolute inset-y-0 right-3 flex items-center pl-3">
                    <svg
                      className=" md:w-6"
                      width="30"
                      height="30"
                      viewBox="0 0 135 135"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 0H134.449V134.449H0V0Z"
                        fill="white"
                        fill-opacity="0.01"
                      />
                      <path
                        d="M67.2231 123.245H22.4067V11.2036H112.04V67.2242"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M99.4365 123.245V86.8313"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M44.8152 44.8159H89.6316"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                      <path
                        d="M44.8152 67.2241H67.2234"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <span className="pl-0 pr-3 py-1">
                    {selectedFile
                      ? selectedFile.name
                      : "Click here to select a file from your computer"}
                  </span>
                  <input
                    id="file-upload"
                    className="absolute inset-0 w-full opacity-0 cursor-pointer"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                      e.target.value = null;
                    }}
                  />
                </div>
              </label>

              <div className="flex gap-5 ">
                <div
                  className="flex flex-col items-center cursor-pointer"
                  onClick={handleOpenModal}
                >
                  <img src={icon.infoIcon} alt="" className="w-5" />
                  <div>Instruction</div>
                </div>

                <div
                  className="flex flex-col items-center cursor-pointer"
                  onClick={handleDownloadTemplate}
                >
                  <img src={icon.downloadIcon} alt="" className="w-5" />
                  <div>Template</div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest Category
            </label>
            <div className="w-3/4 ">
              <CustomSelect
                value={selectedPropertyType}
                onChange={handlePropertyType}
                options={GLPagePropertyTypeList.map((type) => ({
                  value: type.id,
                  label: type.label,
                }))}
                placeholder="Interest property type"
              />
            </div>
          </div>

         
          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest Property
            </label>
            <div className="w-3/4 ">
              <CustomSelect
                value={selectedProperty}
                onChange={handlePropertyChange}
                onInputChange={handleInputChange}
                options={propertyList}
                placeholder="Interest property"
              />
            </div>
          </div>

          <div className="mb-8 flex  items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest Tag
            </label>
            <div className="flex w-3/4   ">
              <CustomSelect
                value={interestTags}
                onChange={handleChange}
                options={options}
                isMulti
                placeholder="Type Interest Tags"
              />
            </div>
          </div>

          <div className="mb-8 flex  items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Interest locations
            </label>
            <div className="flex w-3/4   ">
              <CustomSelect
                value={interestLocationTags}
                onChange={handleLocationChange}
                options={optionLocation}
                isMulti
                placeholder="Type Interest Location"
              />
    
            </div>
          </div>

          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Lead Quality <span className="text-red-600">*</span>
            </label>
            <div className="w-3/4 flex items-center  ">
              <CustomSelect
                value={selectedLevel}
                placeholder="Select Lead Quality"
                onChange={handleSelectChange}
                options={interestLevel}
              />
             
            </div>
          </div>
       

          <div className="flex items-center mb-4">
            {userRole !== "BOD" && (
              <div className="mb-8 flex w-full items-center">
                <label className="w-1/4 text-black text-xl font-medium ">
                  Assign To <AsteriskStyle />
                </label>
                <div className="w-3/4 flex  gap-10">
                  <div className="flex items-center gap-3">
                    <input
                      type="radio"
                      value="Assign to team"
                      id="assign-team"
                      className="w-5 h-5"
                      checked={isAssignedTeam && !isAssignedUser}
                      onChange={() => handleLeadAssignChange("Assign to team")}
                    />
                    <label htmlFor="" className="flex gap-2">
                      Assign to team
                    </label>
                  </div>

                  <div className="flex items-center gap-3">
                    <input
                      type="radio"
                      value="Assign to user"
                      id="assign-user"
                      className="w-5 h-5"
                      checked={isAssignedUser}
                      onChange={() => handleLeadAssignChange("Assign to user")}
                    />
                    <span>Assign to user</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {isAssignedTeam && userRole !== "BOD" && (
            <div className="mb-8 flex items-center">
              <label className="w-1/4 text-black text-xl font-medium ">
                Assign to team <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                {/* <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => handleTeamChange(e.target.value)}
                >
                  <option value="">Select Team</option>
                  {teams.map((item, index) => (
                    <option key={index} value={item.teamId}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
                <CustomSelect
                  options={teams}
                  onChange={handelSelectedTeam}
                  value={selectedTeam}
                />
              </div>
            </div>
          )}

          {(isAssignedUser || userRole === "BOD") && (
            <div className="mb-8 flex items-center">
              <label className="w-1/4 text-black text-xl font-medium ">
                Assign to user <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                {/* <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="">Select User</option>
                  {users.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
                <CustomSelect
                  value={selectedUser}
                  options={users}
                  onChange={handleSelectedUser}
                />
              </div>
            </div>
          )}

          {/* <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Lead Given By
            </label>
            <div className="flex w-3/4 relative">
              <select
                className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="lead-source"
                name="lead-source"
                onChange={(e) => setSelectedLeadGivenBy(e.target.value)}
              >
               
                {!leadGivenUsers ? (
                  <option value="">No more field workers</option>
                ) : (
                  <>
                    <option value="">Select Lead Given By</option>
                    {Array.isArray(leadGivenUsers) &&
                      leadGivenUsers.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </>
                )}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div> */}
          {isModalOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg p-4 md:w-1/2 w-full relative">
                <button
                  onClick={handleCloseModal}
                  className="absolute top-2 right-4 text-black font-bold text-xl"
                >
                  &times;
                </button>
                <h2 className="text-2xl font-semibold mb-4">
                  Excel Template Reference
                </h2>
                <img
                  src={icon.excelImage}
                  alt="Excel Template Reference"
                  className="w-full h-auto"
                />
              </div>
            </div>
          )}
        </form>
      </div>
      <DuplicateLeadDownload
        isOpen={isModalOpen2}
        duplicateLeads={duplicates}
        onClose={() => setIsModalOpen2(false)}
      />
      <BulkCompletedModel
        isOpen={success}
        onClose={() => setSuccess(false)}
        data={leadStatus}
        handleBack={handleBack}
      />
      <ValidationModal
        show={showValidationModal}
        onClose={() => setShowValidationModal(false)}
        errors={validationErrors}
      />

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-4 md:w-1/2 w-full relative">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-4 text-black font-bold text-xl"
            >
              &times;
            </button>
            <h2 className="text-2xl font-semibold mb-4">
              Excel Template Reference
            </h2>
            <img
              src={icon.excelImage}
              alt="Excel Template Reference"
              className="w-full h-auto"
            />
          </div>
        </div>
      )}
      <LeadLimitModel
        isOpen={isModalOpen3}
        onClose={() => setIsModalOpen3(false)}
      />

      <ConfirmationModal
        showModal={openConfirmModal}
        onCancel={() => setOpenConfirmModal(false)}
        onConfirm={handleConfirmUpload}
        title="Confirm Bulk Upload"
        message="Are you sure you want to upload these leads?"
        confirmText="Upload"
        cancelText="Cancel"
      />
    </>
  );
};

export default AdminBulkUpload;

